export default {
	urlcom: 'https://yclapi.cn/',
	//urlcom: 'http://localhost:8000/',
}
